import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHistory = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "history",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_4495_31232",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Bounding box",
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_4495_31232)",
			children: /* @__PURE__ */ _jsx("path", {
				id: "history_2",
				d: "M11.9808 20.5C9.81544 20.5 7.92828 19.7872 6.31928 18.3615C4.71028 16.9358 3.78403 15.1487 3.54053 13H5.07128C5.32378 14.727 6.10103 16.1587 7.40303 17.2952C8.70486 18.4318 10.2308 19 11.9808 19C13.9308 19 15.5849 18.3208 16.9433 16.9625C18.3016 15.6042 18.9808 13.95 18.9808 12C18.9808 10.05 18.3016 8.39583 16.9433 7.0375C15.5849 5.67917 13.9308 5 11.9808 5C10.8884 5 9.86478 5.24267 8.90978 5.728C7.95461 6.21317 7.13211 6.88075 6.44228 7.73075H9.05778V9.23075H3.98078V4.15375H5.48078V6.523C6.29228 5.56533 7.26411 4.82208 8.39628 4.29325C9.52828 3.76442 10.7231 3.5 11.9808 3.5C13.1603 3.5 14.2654 3.72308 15.2963 4.16925C16.3269 4.61542 17.2256 5.22183 17.9923 5.9885C18.7589 6.75517 19.3654 7.65392 19.8115 8.68475C20.2577 9.71542 20.4808 10.8205 20.4808 12C20.4808 13.1795 20.2577 14.2846 19.8115 15.3152C19.3654 16.3461 18.7589 17.2448 17.9923 18.0115C17.2256 18.7782 16.3269 19.3846 15.2963 19.8307C14.2654 20.2769 13.1603 20.5 11.9808 20.5ZM14.9828 16.027L11.2598 12.3038V7H12.7595V11.6962L16.0365 14.973L14.9828 16.027Z",
				fill: "currentColor"
			})
		})]
	})
});
export default SvgHistory;
